/**
 * Small per-visitor preferences in localStorage. Storage can be missing or blocked
 * (private windows, strict privacy settings), so every read and write is guarded
 * and falls back to the default.
 */
export function readStoredBoolean(key, defaultValue) {
  try {
    const storedValue = window.localStorage.getItem(key);
    return storedValue === null ? defaultValue : storedValue === 'true';
  } catch {
    return defaultValue;
  }
}

export function writeStoredBoolean(key, value) {
  try {
    window.localStorage.setItem(key, String(value));
  } catch {
    // Not being able to remember the preference is fine; it just resets next visit.
  }
}
